import { TFormalOffer } from './formalOffers.types';

export const getIsRCFOffer = (formalOffer: TFormalOffer) => {
    return formalOffer.interest_only_repayments === 12;
};
